export interface ForgotPasswordData {
	passwordConfirm: string
	password: string
}

export enum PasswordStrength {
	Strong = 'strong',
	Medium = 'medium',
	Weak = 'weak',
}

export enum Page {
	ResetPassword = '/reset-password',
	SetPassword = '/set-password',
}

export interface PageConfig {
	info: string | undefined
	name: Page
	showConsentCheckboxes: boolean
	subtitle: string
	title: string
}

export enum Role{
	Admin = 'Admin',
	Mentor = 'Mentor',
	Mentee = 'Mentee',
	ApplicantMentee = 'ApplicantMentee'
}

export interface RouteParams {
	token: string
}